/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */
import React from 'react';

import { Tab } from './TabManager';

interface TabBarProps {
    tabs: Tab[];
    activeTabId: string;
    onTabSwitch: (tabId: string) => void;
    onTabClose: (tabId: string) => void;
}

export const TabBar: React.FC<TabBarProps> = ({ tabs, activeTabId, onTabSwitch, onTabClose }) => {
    return (
        <div className="flex bg-slate-800 border-b border-slate-600">
            {tabs.map((tab) => (
                <button
                    key={tab.id}
                    onClick={() => onTabSwitch(tab.id)}
                    className={`px-4 py-1.5 text-sm border-r border-slate-600 flex items-center gap-2 ${
                        activeTabId === tab.id
                            ? 'bg-slate-700 text-white'
                            : 'bg-slate-800 text-slate-300 hover:bg-slate-700'
                    }`}
                >
                    <span className="flex items-center gap-1.5">
                        {tab.name}
                        {tab.isModified && <div className="w-2 h-2 bg-orange-500 rounded-full" title="Modified" />}
                    </span>
                    {!tab.isMainTab && (
                        <button
                            onClick={(e) => {
                                e.stopPropagation();
                                onTabClose(tab.id);
                            }}
                            className="text-slate-400 hover:text-white ml-1"
                        >
                            ×
                        </button>
                    )}
                </button>
            ))}
        </div>
    );
};
